import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { UiEventRaised } from '@cmx/shared/feature/platform-configuration';
import { Dimensions, SeriesData } from '../charts.model';
import { getRandomColor } from '../charts.utils';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'cmx-advance-pie-chart',
  templateUrl: './advance-pie-chart.component.html',
  styleUrls: ['./advance-pie-chart.component.scss'],
})
export class AdvancePieChartComponent extends FieldType implements OnInit {
  @Input() data: SeriesData[] = [
    {
      name: 'Germany',
      value: 8940000,
    },
    {
      name: 'USA',
      value: 5000000,
    },
    {
      name: 'France',
      value: 7200000,
    },
    {
      name: 'UK',
      value: 6200000,
    },
    {
      name: 'Italy',
      value: 4200000,
    },
    {
      name: 'Spain',
      value: 8200000,
    },
  ];
  @Input() dimensions: Dimensions = { width: '', height: '' };
  @Input() allowResize = false;
  @Input() enableGradient = true;
  @Input() label = 'Total';
  @Input() tooltipDisabled = false;
  @Input() enableAnimations = true;
  @Input() itemColor: string[] = [];
  @Input() isFormlyField = true;

  @Output() raisePieChartEvent = new EventEmitter<UiEventRaised>();

  colorScheme: { domain: string[] } = { domain: [] };
  view: [number, number] = [500, 300];

  constructor(private element: ElementRef) {
    super();
  }

  ngOnInit() {
    if (this.isFormlyField) {
      this.dimensions = this.to.dimensions || this.dimensions;
      this.enableGradient = this.to.enableGradient || this.enableGradient;
      this.label = this.to.label || this.label;
      this.tooltipDisabled = this.to.tooltipDisabled || this.tooltipDisabled;
      this.enableAnimations = this.to.enableAnimations || this.enableAnimations;
      this.itemColor = this.to.itemColor || this.itemColor;
      this.allowResize = this.to.allowResize || this.allowResize;
      this.data = this.to.data || this.data;
      this.allowResize = this.to.allowResize || this.allowResize;
    }
    this.resize(this.dimensions.width, this.dimensions.height);
    this.applyColors();
  }

  applyColors() {
    if (this.itemColor && !this.itemColor.length) {
      this.data.forEach(() => {
        this.colorScheme.domain.push(getRandomColor());
      });
    } else this.colorScheme.domain = this.itemColor;
  }

  onSelect(data: unknown): void {
    this.raiseEvent('advance-pie-chart-clicked', data, false);
  }

  raiseEvent(eventName: string, data: unknown, isNavigation: boolean): void {
    const eventToRaise: UiEventRaised = { eventName, data, isNavigation };
    if (this.isFormlyField) {
      this.to.getFieldEvent(eventToRaise);
    } else {
      this.raisePieChartEvent.emit(eventToRaise);
    }
  }

  @HostListener('window:resize')
  onWindowResize() {
    if (this.allowResize) this.resize();
  }

  resize(width?: string | number, height?: string | number, timeout = 0) {
    setTimeout(() => {
      const parentElement = this.element.nativeElement.parentElement.parentElement;
      if (parentElement) {
        this.view = [+(width || parentElement.offsetWidth - 30), +(height || parentElement.offsetHeight - 60)];
      }
    }, timeout);
  }
}
